module.exports = __webpack_public_path__ + "static/media/in_call.a5c43212.svg";